import React from "react";
import { Card, ConfigProvider } from "antd";

interface PropsI {
  children: string | React.ReactNode | React.ReactNode;
  extra?: string | React.ReactNode | React.ReactNode;
  title: string;
  className?: string;
}
const CustomCard = (props: PropsI) => {
  const { extra, children, title, className } = props;
  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            headerBg: "rgb(209 213 219 /1)",
            headerFontSize: 20,
            headerHeight: 60,
          },
        },
      }}
    >
      <Card
        title={title}
        extra={extra}
        className={`mb-4 shadow-md ${className}`}
      >
        {children}
      </Card>
    </ConfigProvider>
  );
};

export default CustomCard;
